import { PoliciesListType } from "@common-shared/config/oneVerify/oneVerifyPolicies.config"

export enum AvailableCoverageHistorySortField {
    timestamp = "timestamp",
    memberFirstName = "memberFirstName",
    memberLastName = "memberLastName",
    memberId = "memberId",
    planName = "planName",
    flags = "flags",
    overrideExpirationDate = "overrideExpirationDate",
    nextAppointment = "nextAppointment",
    patientId = "patientId",
    providerName = "providerName",
    customFieldAppointmentId = "customFieldAppointmentId",
    customFieldAppointmentType = "customFieldAppointmentType",
    customFieldAppointmentStatus = "customFieldAppointmentStatus",
    customFieldRegion = "customFieldRegion",
    customFieldOfficeName = "customFieldOfficeName",
    customFieldPolicyOrder = "customFieldPolicyOrder",
    customFieldCarrierName = "customFieldCarrierName",
    customFieldWorkflowStatus = "customFieldWorkflowStatus",
    customFieldAppointmentCreatedTimestamp = "customFieldAppointmentCreatedTimestamp",
    customFieldCredentialingStatus = "customFieldCredentialingStatus",

    // Assignments fields
    assignmentCreatedAt = "assignmentCreatedAt",
    assignmentStatus = "assignmentStatus",
    assignmentPriority = "assignmentPriority",

    // Agentic fields, not passed to coverage history yet
    agenticCheckStatus = "agenticCheckStatus",
}

export enum AvailableCoverageHistorySortDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export enum CoverageHistoryMode {
    LATEST_COVERAGE = "LATEST_COVERAGE",
    HISTORICAL_COVERAGE = "HISTORICAL_COVERAGE",
}

export const COMMON_COVERAGE_HISTORY_CONFIG = {
    defaultHistoryModeForListViews: CoverageHistoryMode.LATEST_COVERAGE,
    maxReportCsvExportChecks: 100_000,

    get listTypesNotSupportingHistoricalMode(): PoliciesListType[] {
        return [PoliciesListType.AGENTIC]
    },

    get defaultHistoryModeByListType(): Record<
        PoliciesListType,
        CoverageHistoryMode
    > {
        return {
            // Search is the only one that defaults to historical
            [PoliciesListType.HISTORY_SEARCH]:
                CoverageHistoryMode.HISTORICAL_COVERAGE,
            [PoliciesListType.REPORTS]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.MEDICAID]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.OVERRIDES]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.PLAN_YEAR_RESETS]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.TASK_ASSIGNMENTS]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.TASK_ASSIGNMENTS_EXTENDED_CUSTOM_FIELDS]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.TASK_ASSIGNMENTS_MEDICAID]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.ASSIGNED_TASKS]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.ASSIGNED_TASKS_EXTENDED_CUSTOM_FIELDS]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
            [PoliciesListType.ASSIGNED_TASKS_MEDICAID]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,

            // doesn't support yet so value doesn't matter
            [PoliciesListType.AGENTIC]:
                COMMON_COVERAGE_HISTORY_CONFIG.defaultHistoryModeForListViews,
        }
    },
}
